export var JSM_HELP_EXTENSION_TYPE = 'com.atlassian.hub.jsm-help';
export var JSM_HELP_EXTENSION_KEY = 'jsm-help';
export var JSM_HELP_EXTENSION_ANALYTIC_SOURCE = 'jsmHelpExtension';
export var JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'jsmHelpExtensionConfig';
export var JSM_HELP_EXTENSION_VERSION_1 = '1.0.0';
export var CardSize = {
  SMALL: 'small',
  LARGE: 'large'
};
export var SourceType = {
  MANUAL: 'manual',
  COMMON_REQUESTS: 'common-requests'
};